import { createTheme } from '@mui/material';
import boddVariables from '../variables.module.scss';

declare module '@mui/material/styles' {
    interface Theme {
        alerts:{
            [key: string]: {
                text: string | null;
            };
        },
        sampleData:{
            [key: string]: {
                enabled: boolean | null;
            };
        };
    }

    interface ThemeOptions {
        alerts:{
            [key: string]: {
                text: string | null;
            };
        },
        sampleData:{
            [key: string]: {
                enabled: boolean | null;
            };
        };
    }
}

const baseTheme = createTheme({
    palette: {
        primary: {
            main: boddVariables.brandBlue,
        },
    },
    typography: {
        h1: {
            fontFamily: 'Poppins',
            fontSize: '32px',
            fontWeight: '600',
            lineHeight: 'normal',
        },
        h2: {
            fontFamily: 'Poppins',
            fontSize: '24px',
            fontWeight: '600',
            lineHeight: 'normal',
        },
        h3: {
            fontFamily: 'Poppins',
            fontSize: '16px',
            fontWeight: '600',
            lineHeight: '150%',
            letterSpacing: '0.15px',
        },
    },
    components: {
        MuiDivider: {
            styleOverrides: {
                root: {
                    backgroundColor: '#BEBEBE',
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: boddVariables.brandBlue,
                },
            },
        },
        MuiButton: {
            defaultProps: {
                variant: 'contained',
            },
            styleOverrides: {
                contained: {
                    color: boddVariables.white,
                },
                root: {
                    textTransform: 'none',
                    '&.Mui-disabled': {
                        backgroundColor: boddVariables.grey25,
                    },
                },
            },
        },
    },

    alerts: {
        sizeMatch: {
            text: 'Wearing non-skin tight clothing during a scan will skew the accuracy of size recommendations',
        },
        measurements: {
            text: 'Wearing non-skin tight clothing during a scan will skew the accuracy of measurements',
        },
        wellness: {
            text: null,
        },
        bodyComposition: {
            text: null,
        },
    },
    sampleData: {},
});

const boddTheme = createTheme({
    ...baseTheme,
    palette: {
        primary: { main: '#0170D9' },
    },
    alerts: {
        ...baseTheme.alerts,
        wellness: {
            text: 'This is a live demo experience. Scan accuracy may be affected by event conditions, lighting, movement, or scan attire. '
                + 'Health Vitals can be affected by makeup, sunscreen, and face accessories.',
        },
        bodyComposition: {
            text: 'This is a live demo experience. Scan accuracy may be affected by event conditions, lighting, movement, or scan attire.',
        },
    },
});

export const boddDemoTheme = createTheme({
    ...baseTheme,
    palette: {
        primary: { main: '#0170D9' },
    },
    alerts: {
        ...baseTheme.alerts,
        bodyComposition: {
            text: 'The following is sample data only and does not reflect your true reading',
        },
    },
    sampleData: {
        ...baseTheme.sampleData,
        bodyComposition: {
            enabled: true,
        },
    },
});

export const riyadhAirTheme = createTheme({
    ...baseTheme,
    palette: {
        primary: { main: '#5B45DB' },
    },
    alerts: {
        ...baseTheme.alerts,
        sizeMatch: {
            text: 'Size recommendations are based on the intended fit of the manufacturer and don’t account for subjective preference.',
        },
    },
});

export const portwestTheme = createTheme({
    ...baseTheme,
    palette: {
        primary: { main: '#003B49' },
    },
});

export const towerTheme = createTheme({
    ...baseTheme,
    palette: {
        primary: { main: '#00AB84' },
    },
});

export const cooneenTheme = createTheme({
    ...baseTheme,
    palette: {
        primary: { main: '#ED7531' },
    },
});

export const nugentTheme = createTheme({
    ...baseTheme,
    palette: {
        primary: { main: '#1B449C' },
    },
});

export const leidosTheme = createTheme({
    ...baseTheme,
    palette: {
        primary: { main: '#901588' },
    },
});

export const stLogisticsTheme = createTheme({
    ...baseTheme,
    palette: {
        primary: { main: '#0B7B68' },
    },
});

export const britishAirwaysTheme = createTheme({
    ...baseTheme,
    palette: {
        primary: { main: '#2E5C99' },
    },
});

export const gardaTheme = createTheme({
    ...baseTheme,
    palette: {
        primary: { main: '#161F3E' },
    },
});

export const emiratesTheme = createTheme({
    ...baseTheme,
    palette: {
        primary: { main: '#D71921' },
    },
});

export default boddTheme;
